<template>
<md-list-item>
    <md-avatar v-if="collabUser">
        <img :src="collabUser.profile_picture" alt="People" v-if="collabUser.profile_picture" />
        <img :src="require('../../assets/img/silhouette.jpg')" v-else alt="People" />
    </md-avatar>
    <md-avatar v-else>
        <img :src="require('../../assets/img/silhouette.jpg')" alt="People" />
    </md-avatar>
    <div v-if="collabUser" class="md-list-text-container collaborator-text-container">
        <span><strong>{{collabUser.username}}</strong></span>
        <div class="collaborator-role-wrapper">
            <span class="role-text-edit" v-if="isAdministrator || user.uid === collaborator.uid" contenteditable v-on:keydown.esc="cancelEdit" v-on:keydown.left="ignoreKeydown" v-on:keydown.right="ignoreKeydown" v-on:keydown.enter="saveEdit(collaborator.uid, $event)" @blur="stopEdit(collaborator.uid, $event)">{{collaborator.role}}</span>
            <span class="role-text-edit" v-else>{{collaborator.role}}</span>
        </div>
        <span>{{collabUser.email}}</span>
    </div>
    <div v-else class="md-list-text-container collaborator-text-container">
        <span><strong>{{collaborator && collaborator.name || ''}}</strong></span>
        <span>{{collaborator && collaborator.role || ''}}</span>
        <span>{{collaborator && collaborator.email || ''}}</span>
    </div>
    <md-list-expand>
        <md-list class="sub-list">
            <md-list-item>
                <md-layout md-align="center" >
                    <md-layout md-flex="90">
                        <h2 class="md-title">Layer Permissions</h2>
                    </md-layout>
                </md-layout>
                <md-list-expand>
                    <md-list class="sub-list">
                        <md-list-item>
                            <md-layout md-row>
                                <md-layout md-flex="25"><span>Edit</span></md-layout>
                            </md-layout>
                            <span>Layer Name</span>
                        </md-list-item>
                        <layer-permission v-for="layer in layers" :key="layer.id"
                            :layer="layer"
                            :editable="editable"
                            :collaborator="collaborator"/>
                    </md-list>
                </md-list-expand>
            </md-list-item>
            <md-list-item @click="openCollaboratorAccessModal">
                <md-layout md-align="center" >
                    <md-layout md-flex="90">
                        <h2 class="md-title">Collaborator Access</h2>
                    </md-layout>
                </md-layout>
            </md-list-item>
        </md-list>
    </md-list-expand>
</md-list-item>
</template>

<script>
import { mapGetters } from 'vuex';

import CollaboratorsLayerPermission from '@/components/collaborators/layer-permission';

const CollaboratorsCollaborator = {
    name: 'CollaboratorsCollaborator',
    props: ['collaborator', 'user', 'collabUser', 'editable', 'layers'],
    components: {
        layerPermission: CollaboratorsLayerPermission
    },
    data: function() {
        return {
            editing: false
        };
    },
    computed: {
        ...mapGetters([
            'collaboratorByUID',
            'userByUID',
            'ownerUID'
        ]),
        isAdministrator() {
            const collab = this.collaboratorByUID(this.user.uid);
            return this.ownerUID === this.user.uid || (collab && collab.type === 'administrator');
        }
    },
    methods: {
        removeCollaborator() {
            const uid =
                (this.collaborator && (this.collaborator.uid || this.collaborator.id)) ||
                (this.collabUser && (this.collabUser.uid || this.collabUser.id)) ||
                null;
            if (!uid) {
                console.error('[noteslist-integration] removeCollaborator emit missing uid');
                return;
            }
            this.$emit('removeCollaborator', uid);
        },
        ignoreKeydown(e) {
            e.stopPropagation();
        },
        cancelEdit(e) {
            document.execCommand('undo');
            e.target.blur();
        },
        saveEdit(attr, e) {
            e.preventDefault();
            e.target.blur();
        },
        stopEdit(uid, e) {
            this.$store.dispatch('updateCollaboratorOptions', {
                uid,
                role: e.target.innerText
            });
        },
        openCollaboratorAccessModal() {
            this.$emit('close');
            this.$emit('openCollaboratorAccessModal', this.collaborator);
        }
    },
    mounted: function() {
    }
};
export default CollaboratorsCollaborator;
</script>


// WEBPACK FOOTER //
// collaborator.vue?3c748ffc